
import Vue, { PropType } from 'vue';

export interface ToggleOption {
	value: string | boolean;
	label?: string;
	icon?: string;
	[key: string]: any;
}

export default Vue.extend({
	name: 'BaseGreyToggleButton',
	props: {
		value: {
			type: [String, Boolean] as PropType<string | boolean>,
			required: true,
		},
		options: {
			type: Array as PropType<ToggleOption[]>,
			required: true,
			validator: (options: ToggleOption[]) => Array.isArray(options) && options.length >= 2,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		activeIndex (): number {
			const idx = this.options.findIndex((o) => o.value === this.value);
			return idx === -1 ? 0 : idx;
		},
	},
	methods: {
		setOption (option: ToggleOption, event: Event) {
			if (!this.disabled && option.value !== this.value) {
				this.$emit('input', option.value);
			}
			(event.target as HTMLElement).blur();
		},
	},
});
